export const iconFontAwesomeClothingFashionVestPatches = (
	<i className="fa-solid fa-vest-patches"></i>
);
